import * as LicensedInstitution from 'help/institutions/LicensedInstitution';

import * as BroadInstitute from './BroadInstitute';

export enum InstitutionScheduledModal {
  // Keep in sync with benchling/institutions/broad_institute.py
  BROAD_SET_INSTITUTION_MODAL_KEY = 'BROAD_SET_INSTITUTION',
  BROAD_GOOGLE_AUTH_MODAL_KEY = 'BROAD_GOOGLE_AUTH',

  // Keep in sync with benchling/institutions/licensed_institution.py
  LICENSED_INSTITUTION_MODAL_KEY = 'LICENSED_INSTITUTION_MODAL',
}

export const BROAD_SETTINGS_MODAL_KEY = 'BROAD_SETTINGS_MODAL';
export const BROAD_URL_IDENTIFIER = 'broad';

export const InstitutionPreferences = {
  DISMISSED_BROAD_INSTITUTION_MODAL: `dismissed_${BROAD_URL_IDENTIFIER}_institution_modal`,
};

export const institutionInfoLinksByUrl = {
  broad: BroadInstitute.BroadInfoLink,
};

export const LicensedInstitutionInfoLink = LicensedInstitution.LicensedInstitutionInfoLink;
